import { Text } from '@cinch-labs/design-system'
import styles from './confirmation-next-steps.module.css'

const steps = [
  {
    number: '1',
    title: 'Confirmation',
    description:
      "You'll get a booking confirmation email with all the info you need.",
  },
  {
    number: '2',
    title: 'On the day',
    description: 'Bring your car at your chosen appointment time.',
  },
  {
    number: '3',
    title: 'Collection',
    description:
      "We'll let you know when your car's good to go - or discuss your options if it needs a bit more TLC.",
  },
  {
    number: '4',
    title: 'Payment',
    description: "Once the work's done, simply pay by card in-store. Job done.",
  },
]

export const ConfirmationNextSteps = () => (
  <div className={styles.stepsWrapper}>
    <Text element="h2" fontSize="xl" fontWeight="bold">
      What happens next
    </Text>

    {steps.map(({ number, title, description }) => (
      <div key={number} className={styles.step}>
        <div className={styles.stepNumber}>
          <Text fontSize="s" fontWeight="bold" color="meteorite">
            {number}
          </Text>
        </div>
        <div>
          <Text fontSize="m" fontWeight="semibold">
            {title}
          </Text>
          <Text fontSize="s" fontWeight="book">
            {description}
          </Text>
        </div>
      </div>
    ))}
  </div>
)
